import { IF_THEN_BRANCH_KEYS } from '@/models/rule/constants/rule-actions';
import {
  isRuleIfThenAction,
  type BranchKey,
  type RuleAction,
  type RuleFlowAction,
  type RuleIfThenAction
} from '@/models/rule/types';

export const emptyIfThen = (): RuleIfThenAction => ({
  _if: { action: null, then: [], else: [], onError: [] }
});

export const mapIfThenBranches = (
  action: RuleIfThenAction,
  fn: (actions: RuleFlowAction[], key: BranchKey) => RuleFlowAction[]
): RuleIfThenAction => ({
  ...action,
  _if: {
    ...action._if,
    ...Object.fromEntries(
      IF_THEN_BRANCH_KEYS.map((key): [BranchKey, RuleFlowAction[]] => [key, fn(action._if[key], key)])
    )
  }
});

export const ifThenChildren = ({ action, ...branches }: Partial<RuleIfThenAction['_if']>): RuleFlowAction[] => [
  ...(action ? [action] : []),
  ...IF_THEN_BRANCH_KEYS.flatMap((key) => branches[key] ?? [])
];

export const flattenRuleActions = (actions: RuleFlowAction[]): RuleAction[] =>
  actions.flatMap((action) => (isRuleIfThenAction(action) ? flattenRuleActions(ifThenChildren(action._if)) : [action]));
